"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconOnlyStyles = void 0;

var _utils = require("../utils");

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var iconOnlyStyles = function iconOnlyStyles(_ref) {
  var iconOnly = _ref.iconOnly,
      size = _ref.size;
  var isSmall = size === _interfaces.ButtonSize.Small;

  if (iconOnly) {
    var padding = ((isSmall ? _utils.A11Y_MIN_SIZE : _constants.REGULAR_BUTTON_HEIGHT) - _utils.DEFAULT_ICON_SIZE) / 2 - _constants.BORDER_WIDTH;
    return {
      padding: "".concat(padding, "px;")
    };
  }

  return {};
};

exports.iconOnlyStyles = iconOnlyStyles;